const Cor = {
    id:0,
    codigo:"",
    custo: 0,
    unidadeMedida: "",
    ingredientes:[],
}

export default Cor;